angular.module('cian.metroDistance').directive('metroDistance', () => {
  return {
    scope: {},
    bindToController: {},
    template: require('../../templates/metro-distance.html'),
    restrict: 'EA',
    controller: [
      '$rootScope',
      '$timeout',
      'FilterTermsService',
      'ShowOffersService',
      'FilterService',
      'MetroService',
      '$locale',
      function ($rootScope, $timeout, FilterTermsService, ShowOffersService, FilterService, MetroService, $locale) {
        this.terms = FilterTermsService;
        this.filter = FilterService.filter;
        this.isFilterVisible = false;

        const types = {
          "2": 'пешком',
          "-2": 'транспортом'
        };
        const widths = {
          "2": '525px',
          "-2": '558px'
        };

        const pluralWords = {
          one: 'минута',
          few: 'минуты',
          many: 'минут',
          other: 'минут'
        };

        const updateFilterValues = () => {
          this.filter.only_foot.value = this.onlyFoot;
          this.filter.foot_min.value.lte = this.footMin;
        };

        const updateModel = (onlyFoot, footMin) => {
          if (this.onlyFoot !== onlyFoot) this.onlyFoot = onlyFoot;
          if (this.footMin !== footMin) this.footMin = footMin;
        };

        const getTagTitle = (onlyFoot, footMin) => onlyFoot ?
          `До метро ${footMin} ${pluralWords[$locale.pluralCat(footMin)]} ${types[onlyFoot]}` : 'Расстояние до метро';
        this.tagTitle = getTagTitle(this.filter.only_foot.value, this.filter.foot_min.value.lte);

        updateModel(FilterService.filter.only_foot.value, FilterService.filter.foot_min.value.lte);

        this.toggleFilter = () => {
          this.isFilterVisible = !this.isFilterVisible;
        };

        this.save = () => {
          updateFilterValues();
          this.tagTitle = getTagTitle(this.filter.only_foot.value, this.filter.foot_min.value.lte);
          // Модель фильтров успевает обновится
          $timeout(() => {
            ShowOffersService.updateOffers();
            this.toggleFilter();
          }, 0);
        };

        this.closeFilterBlock = () => {
          this.isFilterVisible = false;
          updateModel(FilterService.filter.only_foot.value, FilterService.filter.foot_min.value.lte);
        };

        this.getFiltersWidth = valueType => valueType ? {'width': widths[valueType]} : {'width': '340px'};

        $rootScope.$watch(() => this.onlyFoot, (newValue) => {
          if (newValue === null) {
            this.footMin = null;
          } else {
            this.footMin = this.footMin || MetroService.FOOT_MIN_DEFAULT;
          }
        });

        $rootScope.$watchGroup(
          [() => FilterService.filter.only_foot && FilterService.filter.only_foot.value,
            () => FilterService.filter.foot_min && FilterService.filter.foot_min.value.lte],
          (newValues, oldValues) => {
            if (newValues !== oldValues) {
              updateModel(newValues[0], newValues[1]);
              this.tagTitle = getTagTitle(newValues[0], newValues[1]);
            }
          }
        );
      }],
    link: function (scope, element, attrs, ctrl) {
      $(document).bind('click', function (event) {
        const isClickedElementChildOfThis = element
            .find(event.target)
            .length > 0;
        if (isClickedElementChildOfThis)
          return;
        scope.$apply(function () {
          ctrl.closeFilterBlock();
        });
      });
    },
    controllerAs: 'metroDistance'
  };
});


// WEBPACK FOOTER //
// ./src/components/metro-distance/src/scripts/cian.metro-distance.dir.js